
import BottlerMapDisplay from "../../components/BottlerMapDisplay"

import {
  Paper,
} from "@mui/material";
import { Theme, useTheme } from '@mui/material/styles'
import { createStyles, makeStyles } from '@mui/styles';
import ResponsiveDrawer from "../../components/ClippedResponsiveDrawer";


const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      padding: theme.spacing(2),
      margin: theme.spacing(1),
    },
  })
);


  export default function MapsPage() {
    const classes = useStyles();


  return (
    <ResponsiveDrawer
      title="Map"
    >
      <Paper className={classes.root}>
        <BottlerMapDisplay />
      </Paper>
    </ResponsiveDrawer>
  );
}
